import Personalizer from 'personalizer';
import Localizer from 'localizer';
import ActivitiesUtil from 'utils/activity/ActivitiesUtil';
import { SKI_RUN_SPLIT } from 'constants/TypedSplitsConstants';

var speedType, activity, activityType;

function getSpeedModelforActivity(activityJson) {
    if (!activityJson) {
        throw 'ActivitySpeedModel: activityJson is required.';
    }

    if (activityJson.hasOwnProperty('activityTypeDTO')) {
        activityType = activityJson.activityTypeDTO.typeKey;
    } else if (activityJson.hasOwnProperty('activityType')) {
        activityType = activityJson.activityType.typeKey;
    } else {
        throw 'ActivitySpeedModel: activity type is not defined.';
    }

    speedType = Personalizer.getSpeedTypeFromActivityType(activityType);

    activity = activityJson;

    switch (speedType) {
        case Personalizer.SpeedTypes.SwimPace:
            return getSwimPaceModel(activityType);
            break;
        case Personalizer.SpeedTypes.SwimSpeed:
            return getSwimSpeedModel();
            break;
        case Personalizer.SpeedTypes.Pace:
            return getPaceModel();
            break;
        case Personalizer.SpeedTypes.RowingPace:
            return getRowingPaceModel();
            break;
        case Personalizer.SpeedTypes.RowingSpeed:
            return getRowingSpeedModel();
            break;
        case Personalizer.SpeedTypes.Flying:
            return getFlyingModel();
            break;
        case Personalizer.SpeedTypes.NauticalSpeed:
            return getNauticalSpeedModel();
            break;
        case Personalizer.SpeedTypes.ObstacleRunSpeed:
            return getObstacleRunSpeedModel();
            break;
        case Personalizer.SpeedTypes.ObstacleRunPace:
            return getObstacleRunPaceModel();
            break;
        case Personalizer.SpeedTypes.ResortSkiSpeed:
            return getResortSkiSpeedModel();
            break;
        case Personalizer.SpeedTypes.ResortSkiPace:
            return getResortSkiPaceModel();
            break;
        default:
            return getSpeedModel();
            break;
    }
}

function setSpeedType(speed) {
    speedType = speed;
}

function setActivity(activityJson) {
    activity = activityJson;
}

function getSwimPaceModel(activityType) {
    const poolUnit = activity.unitOfPoolLength ? activity.unitOfPoolLength.unitKey : null;

    let measurementSystem = null;
    if (poolUnit === 'meter') {
        measurementSystem = Personalizer.MeasurementSystems.METRIC;
    } else if (poolUnit === 'yard') {
        measurementSystem = Personalizer.MeasurementSystems.STATUTE_US;
    }

    const speedModel = getSpeedModel();

    let speed = activity.averageSpeed;

    if (speed === 0) {
        speedModel.avgSpeedOrPace = '--';
        speedModel.avgSpeedOrPaceUnit = '';
    } else {
        speedModel.avgSpeedOrPace = Personalizer.personalizeSwimPace(speed, measurementSystem);
        speedModel.avgSpeedOrPaceUnit = Localizer.localize(Personalizer.getSwimPaceUnitKey(measurementSystem));
    }
    speedModel.avgSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgPaceLabelKey('lap_swimming'));
    speedModel.avgMovingSpeedOrPace = Personalizer.personalizeSwimPace(activity.averageMovingSpeed, measurementSystem);
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(Personalizer.getSwimPaceUnitKey(measurementSystem));
    speedModel.avgMovingSpeedOrPaceLabel = Localizer.localize(
        Personalizer.getAvgMovingSpeedTypeLabelKey('lap_swimming')
    );
    speedModel.maxSpeedOrPace = activity.maxSpeed
        ? Personalizer.personalizeSwimPace(activity.maxSpeed, measurementSystem)
        : null;
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(Personalizer.getSwimPaceUnitKey(measurementSystem));
    speedModel.maxSpeedOrPaceLabel = Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey('lap_swimming'));
    speedModel.speedOrPaceLabel = Localizer.localize(Personalizer.getSpeedTypeLabelKey('lap_swimming'));

    return speedModel;
}

function getSwimSpeedModel() {
    var poolUnit = activity.unitOfPoolLength ? activity.unitOfPoolLength.unitKey : null;

    var measurementSystem = null;
    if (poolUnit === 'meter') {
        measurementSystem = Personalizer.MeasurementSystems.METRIC;
    } else if (poolUnit === 'yard') {
        measurementSystem = Personalizer.MeasurementSystems.STATUTE_US;
    }

    var speedModel = getSpeedModel();
    speedModel.avgSpeedOrPace = Personalizer.personalizeSwimSpeed(activity.averageSpeed, measurementSystem);
    speedModel.avgSpeedOrPaceUnit = Localizer.localize(Personalizer.getSwimSpeedUnitKey(measurementSystem));
    speedModel.avgSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgSpeedLabelKey());
    speedModel.avgMovingSpeedOrPace = Personalizer.personalizeSwimSpeed(activity.averageMovingSpeed, measurementSystem);
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(Personalizer.getSwimSpeedUnitKey(measurementSystem));
    speedModel.avgMovingSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgMovingSpeedTypeLabelKey());
    speedModel.maxSpeedOrPace = Personalizer.personalizeSwimSpeed(activity.maxSpeed, measurementSystem);
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(Personalizer.getSwimSpeedUnitKey(measurementSystem));
    speedModel.maxSpeedOrPaceLabel = Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey());
    speedModel.speedOrPaceLabel = Localizer.localize(Personalizer.getSpeedTypeLabelKey());

    return speedModel;
}

function getPaceModel() {
    var speedModel = getSpeedModel();

    speedModel.avgSpeedOrPace = Personalizer.personalizeSpeed(activity.averageSpeed, 'running');
    speedModel.avgSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.avgSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgPaceLabelKey('running'));
    speedModel.avgMovingSpeedOrPace = Personalizer.personalizeSpeed(activity.averageMovingSpeed, 'running');
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.avgMovingSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgMovingSpeedTypeLabelKey('running'));
    speedModel.avgGradeAdjustedSpeedOrPace = Personalizer.personalizeSpeed(activity.avgGradeAdjustedSpeed, 'running');
    speedModel.avgGradeAdjustedSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.maxSpeedOrPace = Personalizer.personalizeSpeed(activity.maxSpeed, 'running');
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.maxSpeedOrPaceLabel = Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey('running'));
    speedModel.speedOrPaceLabel = Localizer.localize(Personalizer.getSpeedTypeLabelKey('running'));

    return speedModel;
}

function getRowingPaceModel() {
    var speedModel = getPaceModel(),
        rowingPaceUnitKey = Personalizer.getRowingPaceUnitKey();

    speedModel.avgSpeedOrPaceUnit = Localizer.localize(rowingPaceUnitKey);
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(rowingPaceUnitKey);
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(rowingPaceUnitKey);

    speedModel.avgMovingSpeedOrPace = Personalizer.personalizeRowingPace(activity.averageMovingSpeed);
    speedModel.maxSpeedOrPace = activity.maxSpeed ? Personalizer.personalizeRowingPace(activity.maxSpeed) : null;
    speedModel.avgSpeedOrPace =
        activity.averageSpeed > 0 ? Personalizer.personalizeRowingPace(activity.averageSpeed) : 0;

    return speedModel;
}

function getRowingSpeedModel() {
    var speedModel = getSpeedModel(),
        rowingSpeedUnitKey = Personalizer.getRowingSpeedUnitKey();

    speedModel.avgSpeedOrPaceUnit = Localizer.localize(rowingSpeedUnitKey);
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(rowingSpeedUnitKey);
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(rowingSpeedUnitKey);

    speedModel.avgMovingSpeedOrPace = Personalizer.formatSpeed(
        Personalizer.convertSpeed(activity.averageMovingSpeed, Personalizer.MeasurementSystems.METRIC, activityType)
    );
    speedModel.maxSpeedOrPace = activity.maxSpeed
        ? Personalizer.formatSpeed(
              Personalizer.convertSpeed(activity.maxSpeed, Personalizer.MeasurementSystems.METRIC, activityType)
          )
        : null;
    speedModel.avgSpeedOrPace = Personalizer.formatSpeed(
        Personalizer.convertSpeed(activity.averageSpeed, Personalizer.MeasurementSystems.METRIC, activityType)
    );

    return speedModel;
}

function getFlyingModel() {
    var speedModel = getSpeedModel();

    speedModel.avgSpeedOrPaceLabel = Localizer.localize(
        Personalizer.getAvgSpeedTypeLabelKey(Personalizer.SpeedTypes.Flying)
    );
    speedModel.avgMovingSpeedOrPaceLabel = Localizer.localize(
        Personalizer.getAvgMovingSpeedTypeLabelKey(Personalizer.SpeedTypes.Flying)
    );
    speedModel.maxSpeedOrPaceLabel = Localizer.localize(
        Personalizer.getMaxSpeedTypeLabelKey(Personalizer.SpeedTypes.Flying)
    );

    return speedModel;
}

function getNauticalPaceModel() {
    var speedModel = getPaceModel(),
        nauticalPaceUnitKey = Personalizer.getNauticalPaceUnitKey();

    speedModel.avgSpeedOrPaceUnit = Localizer.localize(nauticalPaceUnitKey);
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(nauticalPaceUnitKey);
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(nauticalPaceUnitKey);

    speedModel.avgSpeedOrPace = Personalizer.personalizePace(activity.averageSpeed, null, 'boating', false);
    speedModel.avgMovingSpeedOrPace = Personalizer.personalizePace(activity.averageMovingSpeed, null, 'boating');
    speedModel.maxSpeedOrPace = Personalizer.personalizePace(activity.maxSpeed, null, 'boating');

    return speedModel;
}

function getNauticalSpeedModel() {
    let speedModel = getSpeedModel();

    const nauticalSpeedUnit = Localizer.localize(Personalizer.getNauticalSpeedUnitKey());

    speedModel.avgSpeedOrPace = Personalizer.personalizeSpeed(activity.averageSpeed, activityType);
    speedModel.avgSpeedOrPaceUnit = nauticalSpeedUnit;
    speedModel.avgSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgSpeedTypeLabelKey(activityType));

    speedModel.avgMovingSpeedOrPace = Personalizer.personalizeSpeed(activity.averageMovingSpeed, activityType);
    speedModel.avgMovingSpeedOrPaceUnit = nauticalSpeedUnit;
    speedModel.avgMovingSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgMovingSpeedTypeLabelKey(activityType));

    speedModel.maxSpeedOrPace = Personalizer.personalizeSpeed(activity.maxSpeed, activityType);
    speedModel.maxSpeedOrPaceUnit = nauticalSpeedUnit;
    speedModel.maxSpeedOrPaceLabel = Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey(activityType));

    return speedModel;
}

function getSpeedModel() {
    return {
        time: Personalizer.personalizeDuration(activity.duration),
        movingTime: Personalizer.personalizeDuration(activity.movingDuration),
        elapsedTime: Personalizer.personalizeDuration(activity.elapsedDuration),
        avgSpeedOrPace: Personalizer.personalizeSpeed(activity.averageSpeed || activity.avgSpeed, 'cycling'),
        avgSpeedOrPaceUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        avgSpeedOrPaceLabel: Localizer.localize(Personalizer.getAvgSpeedTypeLabelKey('cycling')),
        avgMovingSpeedOrPace: Personalizer.personalizeSpeed(activity.averageMovingSpeed, 'cycling'),
        avgMovingSpeedOrPaceUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        avgMovingSpeedOrPaceLabel: Localizer.localize(Personalizer.getAvgMovingSpeedTypeLabelKey('cycling')),
        maxSpeedOrPace: Personalizer.personalizeSpeed(activity.maxSpeed, 'cycling'),
        maxSpeedOrPaceUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        maxSpeedOrPaceLabel: Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey('cycling')),
        speedOrPaceLabel: Localizer.localize(Personalizer.getSpeedTypeLabelKey('cycling'))
    };
}

function getObstacleRunPaceModel() {
    var speedModel = getSpeedModel();
    const runningSplits = activity.splitSummaries?.filter((summary) => summary.splitType !== 'OBSTACLE');

    const avgSpeedOrPace = runningSplits
        ? runningSplits.reduce((total, next) => total + next.averageSpeed, 0) / runningSplits.length
        : null;
    const avgMovingSpeedOrPace = runningSplits
        ? runningSplits.reduce((total, next) => total + next.averageMovingSpeed, 0) / runningSplits.length
        : null;
    const maxSpeedOrPace = runningSplits ? Math.max(...runningSplits.map((o) => o.maxSpeed)) : null;
    const avgGradeAdjustedSpeed = runningSplits
        ? runningSplits.reduce((total, next) => total + next.avgGradeAdjustedSpeed, 0) / runningSplits.length
        : null;

    speedModel.avgSpeedOrPace = Personalizer.personalizeSpeed(
        avgSpeedOrPace ? avgSpeedOrPace : activity.averageSpeed,
        'running'
    );
    speedModel.avgSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.avgSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgPaceLabelKey());

    speedModel.avgMovingSpeedOrPace = Personalizer.personalizeSpeed(
        avgMovingSpeedOrPace ? avgMovingSpeedOrPace : activity.averageMovingSpeed,
        'running'
    );
    speedModel.avgMovingSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.avgMovingSpeedOrPaceLabel = Localizer.localize(Personalizer.getAvgMovingSpeedTypeLabelKey('running'));

    speedModel.maxSpeedOrPace = Personalizer.personalizeSpeed(
        maxSpeedOrPace ? maxSpeedOrPace : activity.maxSpeed,
        'running'
    );
    speedModel.maxSpeedOrPaceUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.maxSpeedOrPaceLabel = Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey('running'));
    speedModel.speedOrPaceLabel = Localizer.localize(Personalizer.getSpeedTypeLabelKey('running'));

    speedModel.avgGradeAdjustedSpeed =
        Personalizer.personalizeSpeed(
            avgGradeAdjustedSpeed ? avgGradeAdjustedSpeed : activity.avgGradeAdjustedSpeed,
            'running'
        ) || '--';
    speedModel.avgGradeAdjustedSpeedUnit = Localizer.localize(Personalizer.getPaceUnitKey());
    speedModel.avgGradeAdjustedSpeedLabel = Localizer.localize('avg_grade_adjusted_pace');

    return speedModel;
}

function getObstacleRunSpeedModel() {
    const runningSplits = activity.splitSummaries?.filter((summary) => summary.splitType !== 'OBSTACLE');

    const avgSpeedOrPace = runningSplits
        ? runningSplits.reduce((total, next) => total + next.averageSpeed, 0) / runningSplits.length
        : null;
    const avgMovingSpeedOrPace = runningSplits
        ? runningSplits.reduce((total, next) => total + next.averageMovingSpeed, 0) / runningSplits.length
        : null;
    const maxSpeedOrPace = runningSplits ? Math.max(...runningSplits.map((o) => o.maxSpeed)) : null;
    const avgGradeAdjustedSpeed = runningSplits
        ? runningSplits.reduce((total, next) => total + next.avgGradeAdjustedSpeed, 0) / runningSplits.length
        : null;

    return {
        time: Personalizer.personalizeDuration(activity.duration),
        movingTime: Personalizer.personalizeDuration(activity.movingDuration),
        elapsedTime: Personalizer.personalizeDuration(activity.elapsedDuration),

        avgSpeedOrPace: Personalizer.personalizeSpeed(
            avgSpeedOrPace ? avgSpeedOrPace : activity.averageSpeed,
            'cycling'
        ),
        avgSpeedOrPaceUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        avgSpeedOrPaceLabel: Localizer.localize(Personalizer.getAvgSpeedTypeLabelKey('cycling')),

        avgMovingSpeedOrPace: Personalizer.personalizeSpeed(
            avgMovingSpeedOrPace ? avgMovingSpeedOrPace : activity.averageMovingSpeed,
            'cycling'
        ),
        avgMovingSpeedOrPaceUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        avgMovingSpeedOrPaceLabel: Localizer.localize(Personalizer.getAvgMovingSpeedTypeLabelKey('cycling')),

        maxSpeedOrPace: Personalizer.personalizeSpeed(maxSpeedOrPace ? maxSpeedOrPace : activity.maxSpeed, 'cycling'),
        maxSpeedOrPaceUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        maxSpeedOrPaceLabel: Localizer.localize(Personalizer.getMaxSpeedTypeLabelKey('cycling')),
        speedOrPaceLabel: Localizer.localize(Personalizer.getSpeedTypeLabelKey('cycling')),

        avgGradeAdjustedSpeed:
            Personalizer.personalizeSpeed(
                avgGradeAdjustedSpeed ? avgGradeAdjustedSpeed : activity.avgGradeAdjustedSpeed,
                'cycling'
            ) || '--',
        avgGradeAdjustedSpeedUnit: Localizer.localize(Personalizer.getSpeedUnitKey()),
        avgGradeAdjustedSpeedLabel: Localizer.localize('avg_grade_adjusted_speed')
    };
}

function getResortSkiSpeedModel() {
    const speedModel = getSpeedModel();
    const skiRunSplit =
        (activity?.metadataDTO?.hasSplits || activity?.hasSplits) &&
        activity?.splitSummaries?.find((split) => split.splitType === SKI_RUN_SPLIT);

    if (skiRunSplit) {
        speedModel.time = skiRunSplit?.duration
            ? Personalizer.personalizeDuration(skiRunSplit.duration)
            : speedModel.time;

        speedModel.movingTime = skiRunSplit?.movingDuration
            ? Personalizer.personalizeDuration(skiRunSplit.movingDuration)
            : speedModel.movingTime;

        speedModel.elapsedTime = skiRunSplit?.elapsedDuration
            ? Personalizer.personalizeDuration(skiRunSplit.elapsedDuration)
            : speedModel.elapsedTime;

        speedModel.avgSpeedOrPace = skiRunSplit?.averageSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.averageSpeed, 'cycling')
            : speedModel.avgSpeedOrPace;

        speedModel.avgMovingSpeedOrPace = skiRunSplit?.averageMovingSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.averageMovingSpeed, 'cycling')
            : speedModel.avgMovingSpeedOrPace;

        speedModel.avgGradeAdjustedSpeed = skiRunSplit?.avgGradeAdjustedSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.avgGradeAdjustedSpeed, 'cycling') || '--'
            : speedModel.avgGradeAdjustedSpeed;

        speedModel.avgGradeAdjustedSpeedUnit = skiRunSplit?.avgGradeAdjustedSpeed
            ? Localizer.localize(Personalizer.getSpeedUnitKey())
            : speedModel.avgGradeAdjustedSpeedUnit;

        speedModel.avgGradeAdjustedSpeedLabel = skiRunSplit?.avgGradeAdjustedSpeed
            ? Localizer.localize('avg_grade_adjusted_speed')
            : speedModel.avgGradeAdjustedSpeedLabel;

        speedModel.maxSpeedOrPace = skiRunSplit?.maxSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.maxSpeed, 'cycling')
            : speedModel.maxSpeedOrPace;
    }

    return speedModel;
}

function getResortSkiPaceModel() {
    const paceModel = getPaceModel();
    const skiRunSplit =
        (activity?.metadataDTO?.hasSplits || activity?.hasSplits) &&
        activity?.splitSummaries?.find((split) => split.splitType === SKI_RUN_SPLIT);

    if (skiRunSplit) {
        paceModel.avgSpeedOrPace = skiRunSplit?.averageSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.averageSpeed, 'running')
            : paceModel.avgSpeedOrPace;

        paceModel.avgMovingSpeedOrPace = skiRunSplit?.averageMovingSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.averageMovingSpeed, 'running')
            : paceModel.avgMovingSpeedOrPace;

        paceModel.avgGradeAdjustedSpeedOrPace = skiRunSplit?.avgGradeAdjustedSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.avgGradeAdjustedSpeed, 'running')
            : paceModel.avgGradeAdjustedSpeedOrPace;

        paceModel.avgGradeAdjustedSpeed = skiRunSplit?.avgGradeAdjustedSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.avgGradeAdjustedSpeed, 'running') || '--'
            : paceModel.avgGradeAdjustedSpeed;

        paceModel.avgGradeAdjustedSpeedUnit = skiRunSplit?.avgGradeAdjustedSpeed
            ? Localizer.localize(Personalizer.getPaceUnitKey())
            : paceModel.avgGradeAdjustedSpeedUnit;

        paceModel.avgGradeAdjustedSpeedLabel = skiRunSplit?.avgGradeAdjustedSpeed
            ? Localizer.localize('avg_grade_adjusted_pace')
            : paceModel.avgGradeAdjustedSpeedLabel;

        paceModel.maxSpeedOrPace = skiRunSplit?.maxSpeed
            ? Personalizer.personalizeSpeed(skiRunSplit.maxSpeed, 'running')
            : paceModel.maxSpeedOrPace;
    }

    return paceModel;
}

export default {
    getSpeedModelforActivity: getSpeedModelforActivity,
    setSpeedType: setSpeedType,
    setActivity: setActivity,
    getSwimPaceModel: getSwimPaceModel,
    getSwimSpeedModel: getSwimSpeedModel,
    getPaceModel: getPaceModel,
    getSpeedModel: getSpeedModel,
    getRowingPaceModel: getRowingPaceModel,
    getRowingSpeedModel: getRowingSpeedModel,
    getFlyingModel: getFlyingModel,
    getNauticalSpeedModel: getNauticalSpeedModel,
    getNauticalPaceModel: getNauticalPaceModel,
    getObstacleRunPaceModel: getObstacleRunPaceModel,
    getObstacleRunSpeedModel: getObstacleRunSpeedModel,
    getResortSkiSpeedModel: getResortSkiSpeedModel,
    getResortSkiPaceModel: getResortSkiPaceModel
};
